module.exports = __webpack_public_path__ + "static/media/chatwidget.d4265a3a.svg";